export default {
  props: ['grades'],
  template: '#recently_graded_widget_template',
};